import { Box, Button, Flex, Grid, Image, Text, TextInput } from "@mantine/core";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import useStyles from "./style";
import { useForm } from "@mantine/form";
import { forgetPassword, forgetPasswordSkypoint } from "../../services/auth";
import { useMediaQuery } from "@mantine/hooks";
import { useEffect } from "react";
import { pageInfoAnalytics } from "../../config/mixpanelConfig";
import LinePatternSvg from "../../components/Svgs/LinePatternSvg";
const SkypointForgetPassword = () => {
  const { forgotLoading } = useSelector((state) => state.auth);
  const { classes } = useStyles();
  const form = useForm({
    initialValues: {
      email: "",
    },
    validate: {
      email: (value) => (/^\S+@\S+$/.test(value) ? null : "Invalid email"),
    },
  });
  const isResponsive = useMediaQuery("(max-width: 992px)");

  const forgot = (values) => {
    forgetPasswordSkypoint(values);
  };

  useEffect(() => {
    pageInfoAnalytics("Forget Password Page Viewed", "Forget Password Page");
  }, []);
  return (
    <Grid className={classes.container}>
      <Grid.Col span={12} md={6} className={classes.leftCol}>
        <Flex direction="column" align="center" className={classes.leftContent}>
          <Box className={classes.LogoBar} pr={14} pb={20} h={76} w="100%">
            <Image
              src="/assets/images/skypoint-logo2.png"
              height={44}
              width={144}
            />
          </Box>
          <Flex
            direction="column"
            justify="center"
            gap={22}
            className={classes.formAndHdngWrapper}
          >
            <Flex direction="column" gap={12}>
              <Text fz={32} fw={600} ff="Inter" color="#171717">
                Forget Password
              </Text>
            </Flex>

            <form onSubmit={form.onSubmit((values) => forgot(values))}>
              <TextInput
                label="Email"
                className={classes.inputField}
                placeholder="EG.abc@gmail.com"
                size={"lg"}
                {...form.getInputProps("email")}
              />
              <Button
                loading={forgotLoading}
                color="#000"
                mt={20}
                type="submit"
                className={classes.loginBtn}
              >
                Submit
              </Button>
            </form>
            <Flex
              justify="center"
              align="center"
              gap={4}
              className={classes.signupLinkText}
            >
              <Text fz={14} fw={400} ff="Inter" color="#737373">
                Don't have an account?
              </Text>
              <Link className="signupLink" to={"/skypoint-signup"}>
                Sign up
              </Link>
            </Flex>
          </Flex>
        </Flex>
      </Grid.Col>
      <Grid.Col span={12} md={6} className={classes.rightCol}>
        <Flex
          className={classes.rightContent}
          align="center"
          justify="flex-end"
        >
          <Box className={classes.linePattern1Parent}>
            <LinePatternSvg />
          </Box>
          <img
            src="/assets/images/skypoint-dashboard.png"
            alt=""
            className={classes.dashboardImg}
          />
          <Box className={classes.linePattern2Parent}>
            <LinePatternSvg />
          </Box>
        </Flex>
      </Grid.Col>
    </Grid>
  );
};

export default SkypointForgetPassword;
